export default "__VITE_ASSET__1nCYnTxJ__"